import { Icon, ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { View } from 'react-native';
import {
  selectUserAvatar,
  selectUserEmailWithAuthStepEmail,
  selectUserName,
} from 'store/auth/selectors';

import { Image } from 'expo-image';
import { styles } from './styles';

const SIZE = 36;

export const UserChip: React.FC = () => {
  const name = useSelector(selectUserName);
  const email = useSelector(selectUserEmailWithAuthStepEmail);
  const avatar = useSelector(selectUserAvatar);

  return (
    <View style={styles.logo}>
      <View
        style={{
          alignItems: 'center',
          alignSelf: 'center',
          backgroundColor: 'rgba(255,255,255,.5)',
          borderRadius: theme.grid * 3 + 2,
          flexDirection: 'row',
          maxWidth: 300,
          padding: theme.grid,
        }}
      >
        {avatar ? (
          <Image
            source={{ uri: avatar }}
            style={{ borderRadius: SIZE / 2, height: SIZE, width: SIZE }}
          />
        ) : (
          <View style={{ height: SIZE, width: SIZE }}>
            <View
              style={{
                borderColor: '#999',
                borderRadius: SIZE / 2,
                borderWidth: 1,
                height: SIZE,
                overflow: 'hidden',
                position: 'absolute',
                width: SIZE,
              }}
            />
            <Icon
              source={ICONS.CircleUserCustom}
              size={SIZE + 4}
              color="#999"
              style={{ marginLeft: -2, marginTop: -2 }}
            />
          </View>
        )}
        <View>
          {!!name && (
            <Txt
              weight="bold"
              size="large"
              style={{
                paddingLeft: theme.padding,
                paddingRight: theme.padding,
              }}
              numberOfLines={1}
            >
              {name}
            </Txt>
          )}
          <Txt
            weight={name ? 'regular' : 'bold'}
            style={{
              paddingLeft: theme.padding,
              paddingRight: theme.padding,
            }}
            numberOfLines={1}
          >
            {email}
          </Txt>
        </View>
      </View>
    </View>
  );
};
